<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="piii"></a>Early Judaism</h1>
<h1 class="bk1">New Insights and Scholarship</h1>
<p class="bkau">Edited by Frederick E. Greenspahn</p>
<p class="bkpub"><img alt="" height="44" src="images/NYU_TitlePage_Logo.jpg" width="35"/></p>
<p class="bkpub">NEW YORK UNIVERSITY PRESS</p>
<p class="bkpub1">New York</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// greenspahnEarly-0004.vue?85384322